import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  ICreateCustomerInfoPayload,
  ICreateCustomerInfoResponse,
  ICreateCustomerPayload,
  ICreateCustomerResponse,
  IDeleteCustomerInfoPayload,
  IDeleteCustomerInfoResponse,
  IGetCustomerPayload,
  IGetCustomerResponse,
  IGetCustomerReviewsGeoPayload, IGetCustomerReviewsGeoResponse,
  ISearchCustomersPayload,
  ISearchCustomersResponse
} from "../interfaces/ICustomer";

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

export const customerSlice = createApi({
  reducerPath: 'customer',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    }
  }),
  tagTypes: ['Customer'],
  endpoints: (builder) => ({
    createCustomer: builder.mutation<ICreateCustomerResponse, ICreateCustomerPayload>({
      query: (req) => ({
        url: '/customer',
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'POST',
        body: req.body
      })
    }),
    createCustomerInfo: builder.mutation<ICreateCustomerInfoResponse, ICreateCustomerInfoPayload>({
      query: (req) => ({
        url: '/customer-info',
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
        method: 'POST',
        body: req.body
      }),
      invalidatesTags: ['Customer']
    }),
    getCustomer: builder.query<IGetCustomerResponse, IGetCustomerPayload>({
      query: (req) => ({
        url: `/customer?id=${req.id}`,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        }
      }),
      providesTags: ['Customer']
    }),
    searchCustomers: builder.query<ISearchCustomersResponse, ISearchCustomersPayload>({
      query: ({ accessToken, limit, skip, sort, searchQuery }) => ({
        url: `/customers`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        params: {
          limit,
          skip,
          sort,
          searchQuery
        }
      }),
      providesTags: ['Customer']
    }),

    deleteCustomerInfo: builder.mutation<IDeleteCustomerInfoResponse, IDeleteCustomerInfoPayload>({
      query: (req) => ({
        url: `/customer-info?customerInfoId=${req.id}&customerId=${req.customerId}`,
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
      }),
      invalidatesTags: ['Customer']
    }),

    getCustomerReviewsGeo: builder.mutation<IGetCustomerReviewsGeoResponse, IGetCustomerReviewsGeoPayload>({
      query: (req) => ({
        url: `/customer-reviews-geo`,
        method: 'POST',
        body: {range: req.range},
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        },
      }),
    }),
  }),
});

export const {
  useCreateCustomerMutation,
  useCreateCustomerInfoMutation,
  useGetCustomerReviewsGeoMutation,
  useGetCustomerQuery,
  useLazyGetCustomerQuery,
  useDeleteCustomerInfoMutation,
  useSearchCustomersQuery,
} = customerSlice;

